import { render, staticRenderFns } from "./Camera.vue?vue&type=template&id=201b931c&scoped=true"
import script from "./Camera.vue?vue&type=script&lang=js"
export * from "./Camera.vue?vue&type=script&lang=js"
import style0 from "./Camera.vue?vue&type=style&index=0&id=201b931c&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "201b931c",
  null
  
)

export default component.exports